import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen from "./sections/IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen";
import WarumUnsereKiLosungIhrBusinessTransformiert from "./sections/WarumUnsereKiLosungIhrBusinessTransformiert";
import ErlebenSieUnsereKiRezeptionistinInAktion from "./sections/ErlebenSieUnsereKiRezeptionistinInAktion";
import HowItWorks from "./sections/HowItWorks";
import WarumDerVirtuelleAssistent from "./sections/WarumDerVirtuelleAssistent";
import RequestPersonalDemoVideo from "./sections/RequestPersonalDemoVideo";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <IhrKiRezeptionist247ErreichbarFuerIhrUnternehmen />
      <WarumUnsereKiLosungIhrBusinessTransformiert />
      <ErlebenSieUnsereKiRezeptionistinInAktion />
      <HowItWorks />
      <WarumDerVirtuelleAssistent />
      <RequestPersonalDemoVideo />
      <Footer />
    </div>;
}